<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Packs</h1>
  <p class="text-sm text-greyscale-600">Manage client's pack details</p>
  <div class="absolute right-4 top-2 flex items-center gap-2">
    <p-button label="add Pack" icon="pi pi-plus" routerLink="create" />
  </div>
</header>

<main class="p-4">
  <p-table
    #dt
    [value]="packService.packs() ?? []"
    [paginator]="true"
    [rows]="10"
    [globalFilterFields]="['name', 'code', 'description']"
  >
    <!-- En-têtes -->
    <ng-template #header>
      <tr>
        <th>Pack</th>
        <th>Trip limit</th>
        <th>User limit</th>

        <!-- Features en colonnes -->
        <th>Export PDF</th>
        <th>Export Excel</th>
        <th>Client Filter</th>
        <th>Bulk Upload</th>
        <th>Comparison Graph</th>

        <!-- <th>Created</th>
        <th>Updated</th> -->
      </tr>
    </ng-template>

    <ng-template #body let-pack>
      <tr>
        <!-- Name -->
        <td>
          <p-button
            label="{{ pack.name }}"
            routerLink="edit/{{ pack.id }}"
            variant="text"
            icon="pi pi-box"
          />
        </td>

        <!-- Trip limit (range + breakdown tooltip) -->
        <td
          [pTooltip]="breakdownTooltip(pack, 'tripLimit')"
          tooltipPosition="top"
          [style.white-space]="'pre-line'"
        >
          {{ rangeLabel(pack, 'tripLimit') }}
        </td>

        <!-- User limit (range + breakdown tooltip) -->
        <td
          [pTooltip]="breakdownTooltip(pack, 'userLimit')"
          tooltipPosition="top"
          [style.white-space]="'pre-line'"
        >
          {{ rangeLabel(pack, 'userLimit') }}
        </td>

        <!-- Feature: Export PDF -->
        <td class="text-center">
          <i
            class="pi"
            [ngClass]="
              pack.exportPDF
                ? 'pi-check text-green-600'
                : 'pi-times text-red-500'
            "
          ></i>
        </td>

        <!-- Feature: Export Excel -->
        <td class="text-center">
          <i
            class="pi"
            [ngClass]="
              pack.exportExcel
                ? 'pi-check text-green-600'
                : 'pi-times text-red-500'
            "
          ></i>
        </td>

        <!-- Feature: Client Filter -->
        <td class="text-center">
          <i
            class="pi"
            [ngClass]="
              pack.clientFilter
                ? 'pi-check text-green-600'
                : 'pi-times text-red-500'
            "
          ></i>
        </td>

        <!-- Bulk Upload (max files per batch, range + breakdown tooltip) -->
        <td
          class="text-center"
          [pTooltip]="breakdownTooltip(pack, 'bulkUpload')"
          tooltipPosition="top"
          [style.white-space]="'pre-line'"
        >
          {{ rangeLabel(pack, 'bulkUpload') }}
        </td>

        <!-- Comparison Graph -->
        <td class="text-center">
          <i
            class="pi"
            [ngClass]="
              pack.comparisonGraph
                ? 'pi-check text-green-600'
                : 'pi-times text-red-500'
            "
          ></i>
        </td>
      </tr>
    </ng-template>
  </p-table>
</main>
